import { CrudRequestStateShared } from '@core/shared/crud';
import * as i0 from "@angular/core";
export let CrudRequestState = /*#__PURE__*/(() => {
  class CrudRequestState extends CrudRequestStateShared {
    constructor() {
      super();
    }
    static {
      this.ɵfac = function CrudRequestState_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CrudRequestState)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: CrudRequestState,
        factory: CrudRequestState.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CrudRequestState;
})();